import script from "./InitialLiquidity.vue?vue&type=script&setup=true&lang=ts"
export * from "./InitialLiquidity.vue?vue&type=script&setup=true&lang=ts"

import "./InitialLiquidity.vue?vue&type=style&index=0&id=36527763&lang=css"

const __exports__ = script;

export default __exports__